import { RECRUITEE_BACKEND } from '@core/environment-legacy/staging';

import type { AccountSetupEnvironment } from './interface';
export const environment: AccountSetupEnvironment = {
  environmentName: 'staging',
  angularProdMode: true,
  hmr: false,
  analytics: {
    isEnabled: true,
    key: '57b8b354c54a93cd67f0e70c1fa6fc8b',
    requiredFeatureFlag: false,
  },
  i18n: {
    phraseAppProjectId: 'cea66a528621d963077fdbb152355ac8',
    editorEnabled: true,
  },
  protocol: RECRUITEE_BACKEND.protocol,
  domain: RECRUITEE_BACKEND.domain,
  webappUrl: RECRUITEE_BACKEND.webAppUrl,
  landingPageUrl: RECRUITEE_BACKEND.appUrl,
  apiUserUrl: `${RECRUITEE_BACKEND.authUrl}/sign-up-admin`,
  apiSSOUserUrl: `${RECRUITEE_BACKEND.authUrl}/sign-up-sso`,
  apiADPUserUrl: `${RECRUITEE_BACKEND.authUrl}/sign-up-adp`,
  apiUserDataUrl: `${RECRUITEE_BACKEND.authUrl}/invitation/`,
  apiLocalizationSettingsUrl: `${RECRUITEE_BACKEND.apiUrl}/localization_settings`,
  apiCompanyUrl: `${RECRUITEE_BACKEND.authUrl}/sign-up`,
  apiCompanyDataUrl: `${RECRUITEE_BACKEND.authUrl}/sign-up-confirmation/`,
  appAuthUrl: `${RECRUITEE_BACKEND.authUrl}/`,
  signInUrl: `${RECRUITEE_BACKEND.authUrl}/sign-in/`,
  emailConfirmationUrl: `${RECRUITEE_BACKEND.authUrl}/email-confirmation/`,
  supportEmail: 'support@tellent.com',
  growsumoPublicKey: 'pk_86389cd9dcf0488c81b2113893302a82',
  sentry: {
    dsn: 'https://b5f141b4ea5246248086654e6889e42d@o18167.ingest.us.sentry.io/1807448',
    environmentName: 'staging',
  },
  tellentCompanyAuthUrl: `${RECRUITEE_BACKEND.tellentAuthUrl}/api/sign-up`,
  tellentApiUserDataUrl: `${RECRUITEE_BACKEND.tellentAuthUrl}/api/invitations`,
  tellentApiUserUrl: `${RECRUITEE_BACKEND.tellentAuthUrl}/api/users/sign-up`,
  tellentApiSSOUserUrl: `${RECRUITEE_BACKEND.tellentAuthUrl}/api/sso/users/sign-up`,
  tellentAuthUrl: `${RECRUITEE_BACKEND.tellentAuthUrl}/`,
};
